<ion-header>
  <ion-toolbar color="primary">
    <ion-title>A tanév rendje – rendelet beemelése</ion-title>
    <ion-buttons slot="end"><ion-button (click)="bezar()">Bezár</ion-button></ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <p class="sug">A minisztérium minden évben rendeletben adja ki a tanév rendjét. A rendszer a Nemzeti Jogszabálytárból olvassa be,
    és a kiválasztott dátumokat a naptárba emeli (a szüneteket a tanügyi naptárba is).</p>

  <div class="sor">
    <ion-select label="Tanév" label-placement="stacked" interface="popover" [(ngModel)]="tanev" (ionChange)="beolvas()">
      <ion-select-option *ngFor="let t of tanevek" [value]="t">{{ t }}/{{ t + 1 }}</ion-select-option>
    </ion-select>
    <ion-input label="A rendelet njt-linkje (nem kötelező)" label-placement="stacked" [(ngModel)]="njt"
               placeholder="https://njt.hu/jogszabaly/…"></ion-input>
    <ion-button fill="outline" (click)="beolvas()" [disabled]="toltodik"><ion-icon slot="start" name="refresh"></ion-icon>Beolvasás</ion-button>
  </div>

  <div class="kozep" *ngIf="toltodik"><ion-spinner></ion-spinner><p>A rendelet beolvasása…</p></div>
  <div class="hiba" *ngIf="hiba">{{ hiba }}</div>

  <ng-container *ngIf="elonezet && !kesz">
    <div class="rendelet">
      <b>{{ elonezet.rendelet.cim }}</b> · <a [href]="elonezet.rendelet.url" target="_blank" rel="noopener">njt</a>
      <div class="halvany">Tanítási év: {{ elonezet.tanev.elso }} – {{ elonezet.tanev.utolso }} · félév vége: {{ elonezet.tanev.felev }}{{ elonezet.tanev.napok ? ' · tanítási napok: ' + elonezet.tanev.napok : '' }}</div>
    </div>

    <ion-item lines="none" *ngIf="elonezet.jelenlegi && hatarValtozik">
      <ion-checkbox slot="start" [(ngModel)]="tanevHatarok"></ion-checkbox>
      <ion-label class="ion-text-wrap">A tanév határainak átírása a rendelet szerint
        <p>most: {{ elonezet.jelenlegi.tankezd }} – {{ elonezet.jelenlegi.tanvege }}, félév: {{ elonezet.jelenlegi.felev }}</p></ion-label>
    </ion-item>
    <p class="halvany" *ngIf="!elonezet.jelenlegi">Ez a tanév még nincs megnyitva a Tanévváltóban – a határait ott lehet felvenni; a naptárbejegyzések így is beemelhetők.</p>
    <p class="halvany" *ngIf="elonezet.jelenlegi && !hatarValtozik">A tanév határai már egyeznek a rendelettel.</p>

    <ion-list lines="full">
      <ion-item *ngFor="let e of elonezet.esemenyek" [class.halvany-sor]="e.megvan || e.nem_relevans">
        <ion-checkbox slot="start" [(ngModel)]="valasztott[e.kulcs]"></ion-checkbox>
        <ion-label class="ion-text-wrap">
          <h3>{{ e.nev }} <span class="cimke">{{ tipusNev[e.tipus] || e.tipus }}</span></h3>
          <p>{{ e.kezdes }}{{ e.vege !== e.kezdes ? ' – ' + e.vege : '' }}<span *ngIf="e.holiday_tipus === 1"> · iskolai szünet (az órák kikerülnek)</span></p>
          <p class="megvan" *ngIf="e.megvan">Már szerepel a naptárban: {{ e.megvan }}</p>
          <p class="megvan" *ngIf="e.nem_relevans">Az intézményre nem vonatkozik (évfolyamok alapján)</p>
        </ion-label>
      </ion-item>
    </ion-list>
  </ng-container>

  <div class="kesz" *ngIf="kesz">
    <ion-icon name="checkmark-circle" color="success"></ion-icon>
    <p><b>{{ kesz.letrehozva }}</b> bejegyzés a naptárba került{{ kesz.tanev_frissitve ? ', a tanév határai frissültek' : '' }}.</p>
    <p class="hiba" *ngFor="let h of kesz.hibak">{{ h }}</p>
  </div>
</ion-content>
<ion-footer *ngIf="elonezet && !kesz">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="bezar()">Mégse</ion-button>
      <ion-button fill="solid" color="primary" (click)="beemel()" [disabled]="fut || (!kijeloltDb && !(tanevHatarok && hatarValtozik))">
        <ion-icon slot="start" name="download-outline"></ion-icon>{{ fut ? 'Beemelés…' : 'Beemelés (' + kijeloltDb + ')' }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
